import { render, staticRenderFns } from "./StudentAddCommentSlidebar.vue?vue&type=template&id=13d93d24"
import script from "./StudentAddCommentSlidebar.vue?vue&type=script&lang=js"
export * from "./StudentAddCommentSlidebar.vue?vue&type=script&lang=js"
import style0 from "./StudentAddCommentSlidebar.vue?vue&type=style&index=0&id=13d93d24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports